<div class="modal-container">
  <div class="modal-header alt-flex-row alt-between">
    <p class="modal-title alt-inter-semibold alt-size-20 alt-color-grayscale1">
      Crear cuenta
    </p>

    <mat-icon
      class="pointer"
      svgIcon="crossMenu"
      (click)="closeModal()"
    ></mat-icon>
  </div>

  <form
    [formGroup]="userAlliedForm"
    class="modal-body"
    (ngSubmit)="sendData(userAlliedForm)"
  >
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Correo electrónico</mat-label>
      <input
        matInput
        formControlName="email"
        placeholder="usuario@correo.com"
      />

      <mat-error
        *ngIf="
          userAlliedForm.get('email')?.hasError('required') &&
          userAlliedForm.get('email')?.touched
        "
      >
        El correo es requerido
      </mat-error>

      <mat-error
        *ngIf="
          userAlliedForm.get('email')?.hasError('email') &&
          userAlliedForm.get('email')?.touched
        "
      >
        Ingresa un correo válido
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Rol</mat-label>
      <mat-select formControlName="role">
        <mat-option value="Standard">Estándar</mat-option>
        <mat-option value="Premium">Premium</mat-option>
      </mat-select>
    </mat-form-field>

    <div class="modal-footer alt-flex-row alt-end">
      <button
        class="cancel-btn"
        mat-button
        type="button"
        (click)="closeModal()"
        [disabled]="isCreating"
      >
        Cancelar
      </button>

      <button
        class="save-btn"
        mat-button
        type="submit"
        [disabled]="isCreating"
      >
        {{ isCreating ? 'Creando...' : 'Crear cuenta' }}
      </button>
    </div>
  </form>
</div>